import React, { useState, useRef, useEffect } from "react";
import InvitCard from "../../../asset/invt_card.jpg";
import waiverCode from "../../../asset/waiver.png";
import styles from "./invitationCard.module.css";
import { postRequest } from "../../../util/request/request";
import { authPost } from "../../../util/request/authPost";
import {
  Modal,
  Box,
  TextField,
  Button,
  Typography,
  Stack,
  useStepContext,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { authPut } from "../../../util/request/authPut";

function convertTo12HourTimeCompact(time24) {
  const [hour, minute] = time24.split(":").map(Number);
  const period = hour >= 12 ? "PM" : "AM";
  const hour12 = hour % 12 || 12;
  return minute === 0
    ? `${hour12} ${period}`
    : `${hour12}:${minute.toString().padStart(2, "0")} ${period}`;
}

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  height: "90%",
  // bgcolor: "background.paper",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const InvitationCard = (props) => {
  const canvasRef = useRef(null); // Reference to the canvas element
  const [image, setImage] = useState(InvitCard); // Store the loaded image

  console.log(props.inviteInfo);
  console.log(props.inviteInfo.bookingDetail.celebrant);

  const sendEmailInvitation = async () => {
    // Generate the image data from the canvas (with modifications)
    const imageData = canvasRef.current.toDataURL("image/png");

    const sendEmail = await authPost({
      subLink: "booking/getinvitationcard",
      data: { ...imageData },
    });
    console.log(imageData);
  };

  const drawImageWithText = (img, zoomLevel) => {
    const canvas = canvasRef.current;
    console.log(canvas);
    const ctx = canvas.getContext("2d");

    // Set canvas dimensions to match the original image
    canvas.width = img.width;
    canvas.height = img.height;

    // Clear canvas
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Apply zoom scaling to display the image
    ctx.save(); // Save the current state
    ctx.scale(zoomLevel, zoomLevel);

    // Draw the image on the canvas

    ctx.drawImage(img, 0, 0, img.width, img.height);

    const code = new Image();
    code.src = waiverCode;
    code.onload = () => {
      ctx.drawImage(code, 55, 1460);
    };
    //
    // Add text overlay
    ctx.font = "50px Arial";
    ctx.fillStyle = "purple";
    const partyDate = props.inviteInfo.bookingDetail.party_date;
    const toTime =
      props.inviteInfo.bookingDetail.party_time.slice(0, 2) * 1 + 2;
    // :00}`
    ctx.fillText(`${props.inviteInfo.bookingDetail.celebrant}'s`, 600, 300);
    ctx.fillText(partyDate.slice(5) + "-" + partyDate.slice(0, 4), 500, 1430); // Add text at (20, 50)
    ctx.fillText(
      `${convertTo12HourTimeCompact(
        props.inviteInfo.bookingDetail.party_time
      )} - ${convertTo12HourTimeCompact(toTime.toString() + ":00")}`,

      500,
      1505
    ); // Add text at (20, 50)
    ctx.fillText(props.inviteInfo.bookingDetail.phone_number, 500, 1675); // Add text at (20, 50)
    // Add dynamic text (if provided)
    // if (text) {
    //   ctx.fillText(text, 100, 200);
    // }

    ctx.restore(); // Restore original state (no scaling applied for further operations)
  };

  const downloadImage = () => {
    const canvas = canvasRef.current;

    // Generate the image data from the canvas (with modifications)
    const imageData = canvas.toDataURL("image/png");

    // Create a link to download the image
    const link = document.createElement("a");
    link.href = imageData;
    link.download = "Invitation_Card.png";
    link.click();
  };

  useEffect(() => {
    // setWaiverImg(code);

    const img = new Image();
    img.src = InvitCard; // Replace with your image path
    // const code = new Image();
    // code.src = waiverCode;

    img.onload = () => {
      setImage(img); // Store the loaded image
      drawImageWithText(img, 1); // Initial draw with default zoom
    };
    // code.onload = () => {
    //   setImage(code); // Store the loaded image
    //   drawImageWithText(code, 50, 50); // Initial draw with default zoom
    // };
  }, [props]);

  return (
    <Box>
      <Modal open={true} sx={style}>
        <Stack
          spacing={2}
          alignItems="center"
          justifyContent="center"
          sx={{ bgcolor: "white", width: "100%", height: "100%" }}
        >
          <Box>
            <canvas ref={canvasRef} className={styles.canvas}></canvas>
          </Box>

          <Stack direction="row" spacing={2}>
            <Button
              onClick={() => {
                props.onClose();
              }}
              variant="contained"
            >
              Close
            </Button>
            <Button onClick={downloadImage} variant="contained">
              Download
            </Button>

            {/* <Button onClick={sendEmailInvitation} variant="contained">
              Email
            </Button> */}
          </Stack>
        </Stack>
      </Modal>
    </Box>
  );
};

export default InvitationCard;
